import colors from "../../constants/colors";

const styles = (theme) => {
  return {
    header: {
      color: colors.white,
    },
    container: {
      display: "flex",
      "flex-direction": "row",
      "justify-content": "center",
      "align-items": "center",
      height: "100%",
      width: "100%",
    },
    loader: {
      "justify-content": "center",
      "align-items": "center",
    },
  };
};

export default styles;
